{
  "_meta": {
    "description": "Product registry \u2014 single source of truth for resolving ARI/ATI to product info.",
    "usage": "Extract resourceOwner from ARI/ATI (segment index 2), lookup in products map.",
    "ariFormat": "ari:{platform}:{resourceOwner}:{qualifier}:{resourceType}/{resourceId}",
    "atiFormat": "ati:{platform}:{resourceOwner}:{resourceType}",
    "generatedAt": "2026-04-21T16:31:52.000Z"
  },
  "products": {
    "media": {
      "resourceOwner": "media",
      "platform": "cloud",
      "isThirdParty": false,
      "displayName": "Media",
      "logo": null,
      "notNeeded": true,
      "resourceTypes": {
        "file": {
          "resourceType": "file",
          "template": "ari:cloud:media::file/{fileId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/file",
            "exportName": "default"
          }
        }
      }
    },
    "identity": {
      "resourceOwner": "identity",
      "platform": "cloud",
      "isThirdParty": false,
      "displayName": "Identity",
      "logo": null,
      "notNeeded": false,
      "resourceTypes": {
        "group": {
          "resourceType": "group",
          "template": "ari:cloud:identity::group/{groupId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/people-group",
            "exportName": "default"
          }
        },
        "scoped-group": {
          "resourceType": "scoped-group",
          "template": "ari:cloud:identity::scoped-group/{scopeType}/{scopeId}/{groupId}",
          "icon": null
        },
        "team-type": {
          "resourceType": "team-type",
          "template": "ari:cloud:identity::team-type/{directoryId}/{teamTypeId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/teams",
            "exportName": "default"
          }
        },
        "team": {
          "resourceType": "team",
          "template": "ari:cloud:identity::team/{teamId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/teams",
            "exportName": "default"
          }
        },
        "team-custom-field-value": {
          "resourceType": "team-custom-field-value",
          "template": "ari:cloud:identity::team-custom-field-value/{directoryId}/{teamCustomFieldId}/{teamCustomFieldValueId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/teams",
            "exportName": "default"
          }
        },
        "third-party-user": {
          "resourceType": "third-party-user",
          "template": "ari:cloud:identity::third-party-user/{directoryId}/{userId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/person-avatar",
            "exportName": "default"
          }
        },
        "user": {
          "resourceType": "user",
          "template": "ari:cloud:identity::user/{userId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/person-avatar",
            "exportName": "default"
          }
        }
      }
    },
    "loom": {
      "resourceOwner": "loom",
      "platform": "cloud",
      "isThirdParty": false,
      "displayName": "Loom",
      "logo": {
        "source": "atlaskit-raw-icon",
        "importPath": "@atlaskit/logo/raw-icons",
        "exportName": "loomIcon"
      },
      "notNeeded": false,
      "resourceTypes": {
        "video": {
          "resourceType": "video",
          "template": "ari:cloud:loom:{siteId}:video/activation/{activationId}/{videoId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/video",
            "exportName": "default"
          }
        },
        "space": {
          "resourceType": "space",
          "template": "ari:cloud:loom:{siteId}:space/activation/{activationId}/{spaceId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/compass",
            "exportName": "default"
          }
        },
        "meeting": {
          "resourceType": "meeting",
          "template": "ari:cloud:loom:{siteId}:meeting/activation/{activationId}/{meetingId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/calendar",
            "exportName": "default"
          }
        },
        "meeting-recurrence": {
          "resourceType": "meeting-recurrence",
          "template": "ari:cloud:loom:{siteId}:meeting-recurrence/activation/{activationId}/{meetingRecurrenceId}",
          "icon": {
            "source": "atlaskit-icon-lab",
            "importPath": "@atlaskit/icon-lab/core/repeat",
            "exportName": "default"
          }
        },
        "comment": {
          "resourceType": "comment",
          "template": "ari:cloud:loom:{siteId}:comment/activation/{activationId}/{commentId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/comment",
            "exportName": "default"
          }
        }
      }
    },
    "confluence": {
      "resourceOwner": "confluence",
      "platform": "cloud",
      "isThirdParty": false,
      "displayName": "Confluence",
      "logo": {
        "source": "atlaskit-logo",
        "importPath": "@atlaskit/logo/confluence-icon",
        "exportName": "ConfluenceIcon"
      },
      "notNeeded": false,
      "resourceTypes": {
        "attachment": {
          "resourceType": "attachment",
          "template": "ari:cloud:confluence:{siteId}:attachment/{attachmentId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/attachment",
            "exportName": "default"
          }
        },
        "blogpost": {
          "resourceType": "blogpost",
          "template": "ari:cloud:confluence:{siteId}:blogpost/{blogpostId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/quotation-mark",
            "exportName": "default"
          }
        },
        "comment": {
          "resourceType": "comment",
          "template": "ari:cloud:confluence:{siteId}:comment/{commentId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/comment",
            "exportName": "default"
          }
        },
        "content": {
          "resourceType": "content",
          "template": "ari:cloud:confluence:{siteId}:content/{contentId}",
          "icon": null
        },
        "database": {
          "resourceType": "database",
          "template": "ari:cloud:confluence:{siteId}:database/activation/{activationId}/{databaseId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/database",
            "exportName": "default"
          }
        },
        "embed": {
          "resourceType": "embed",
          "template": "ari:cloud:confluence:{siteId}:embed/activation/{activationId}/{embedId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/smart-link-embed",
            "exportName": "default"
          }
        },
        "folder": {
          "resourceType": "folder",
          "template": "ari:cloud:confluence:{siteId}:folder/activation/{activationId}/{folderId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/folder-closed",
            "exportName": "default"
          }
        },
        "page": {
          "resourceType": "page",
          "template": "ari:cloud:confluence:{siteId}:page/{pageId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/page",
            "exportName": "default"
          }
        },
        "space": {
          "resourceType": "space",
          "template": "ari:cloud:confluence:{siteId}:space/{spaceId}",
          "icon": {
            "source": "atlaskit-icon-lab",
            "importPath": "@atlaskit/icon-lab/core/spaces",
            "exportName": "default"
          }
        },
        "whiteboard": {
          "resourceType": "whiteboard",
          "template": "ari:cloud:confluence:{siteId}:whiteboard/{whiteboardId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/whiteboard",
            "exportName": "default"
          }
        }
      }
    },
    "jira": {
      "resourceOwner": "jira",
      "platform": "cloud",
      "isThirdParty": false,
      "displayName": "Jira",
      "logo": {
        "source": "atlaskit-logo",
        "importPath": "@atlaskit/logo/jira-icon",
        "exportName": "JiraIcon"
      },
      "notNeeded": false,
      "resourceTypes": {
        "branch": {
          "resourceType": "branch",
          "template": "ari:cloud:jira:{siteId}:branch/activation/{activationId}/{branchId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/branch",
            "exportName": "default"
          }
        },
        "build": {
          "resourceType": "build",
          "template": "ari:cloud:jira:{siteId}:build/activation/{activationId}/{buildId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/release",
            "exportName": "default"
          }
        },
        "commit": {
          "resourceType": "commit",
          "template": "ari:cloud:jira:{siteId}:commit/activation/{activationId}/{commitId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/commit",
            "exportName": "default"
          }
        },
        "connect-app": {
          "resourceType": "connect-app",
          "template": "ari:cloud:jira:{siteId}:connect-app/activation/{activationId}/{appKey}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/app",
            "exportName": "default"
          }
        },
        "deployment": {
          "resourceType": "deployment",
          "template": "ari:cloud:jira:{siteId}:deployment/activation/{activationId}/{deploymentId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/release",
            "exportName": "default"
          }
        },
        "design": {
          "resourceType": "design",
          "template": "ari:cloud:jira:{siteId}:design/activation/{activationId}/{designId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/whiteboard",
            "exportName": "default"
          }
        },
        "devops-component": {
          "resourceType": "devops-component",
          "template": "ari:cloud:jira:{siteId}:devops-component/activation/{activationId}/{devopsComponentId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/operations",
            "exportName": "default"
          }
        },
        "document": {
          "resourceType": "document",
          "template": "ari:cloud:jira:{siteId}:document/activation/{activationId}/{documentId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/file",
            "exportName": "default"
          }
        },
        "feature-flag": {
          "resourceType": "feature-flag",
          "template": "ari:cloud:jira:{siteId}:feature-flag/activation/{activationId}/{featureFlagId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/flag",
            "exportName": "default"
          }
        },
        "incident": {
          "resourceType": "incident",
          "template": "ari:cloud:jira:{siteId}:incident/activation/{activationId}/{incidentId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/incident",
            "exportName": "default"
          }
        },
        "issue-comment": {
          "resourceType": "issue-comment",
          "template": "ari:cloud:jira:{siteId}:issue-comment/{issueId}/{commentId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/comment",
            "exportName": "default"
          }
        },
        "issue-remote-link": {
          "resourceType": "issue-remote-link",
          "template": "ari:cloud:jira:{siteId}:issue-remote-link/activation/{activationId}/{issueId}/{linkId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/task",
            "exportName": "default"
          }
        },
        "issue-status": {
          "resourceType": "issue-status",
          "template": "ari:cloud:jira:{siteId}:issue-status/activation/{activationId}/{issuestatusId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/task",
            "exportName": "default"
          }
        },
        "issue-type": {
          "resourceType": "issue-type",
          "template": "ari:cloud:jira:{siteId}:issue-type/{issueTypeId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/task",
            "exportName": "default"
          }
        },
        "issue-worklog": {
          "resourceType": "issue-worklog",
          "template": "ari:cloud:jira:{siteId}:issue-worklog/{issueId}/{worklogId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/task",
            "exportName": "default"
          }
        },
        "issue": {
          "resourceType": "issue",
          "template": "ari:cloud:jira:{siteId}:issue/{issueId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/task",
            "exportName": "default"
          }
        },
        "operations-workspace": {
          "resourceType": "operations-workspace",
          "template": "ari:cloud:jira:{siteId}:operations-workspace/activation/{activationId}/{providerAppId}/{operationsWorkspaceId}",
          "icon": {
            "source": "atlaskit-icon-lab",
            "importPath": "@atlaskit/icon-lab/core/spaces",
            "exportName": "default"
          }
        },
        "post-incident-review-link": {
          "resourceType": "post-incident-review-link",
          "template": "ari:cloud:jira:{siteId}:post-incident-review-link/activation/{activationId}/{postIncidentReviewLinkId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/link",
            "exportName": "default"
          }
        },
        "post-incident-review": {
          "resourceType": "post-incident-review",
          "template": "ari:cloud:jira:{siteId}:post-incident-review/activation/{activationId}/{postIncidentReviewId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/alert",
            "exportName": "default"
          }
        },
        "priority": {
          "resourceType": "priority",
          "template": "ari:cloud:jira:{siteId}:priority/activation/{activationId}/{priorityId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/priority-critical",
            "exportName": "default"
          }
        },
        "project": {
          "resourceType": "project",
          "template": "ari:cloud:jira:{siteId}:project/{projectId}",
          "icon": {
            "source": "atlaskit-icon-lab",
            "importPath": "@atlaskit/icon-lab/core/spaces",
            "exportName": "default"
          }
        },
        "pull-request": {
          "resourceType": "pull-request",
          "template": "ari:cloud:jira:{siteId}:pull-request/activation/{activationId}/{pullRequestId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/pull-request",
            "exportName": "default"
          }
        },
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:cloud:jira:{siteId}:remote-link/activation/{activationId}/{remoteLinkId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/link-external",
            "exportName": "default"
          }
        },
        "repository": {
          "resourceType": "repository",
          "template": "ari:cloud:jira:{siteId}:repository/activation/{activationId}/{repositoryId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/angle-brackets",
            "exportName": "default"
          }
        },
        "security-container": {
          "resourceType": "security-container",
          "template": "ari:cloud:jira:{siteId}:security-container/activation/{activationId}/{providerAppId}/{securityContainerId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/shield",
            "exportName": "default"
          }
        },
        "security-workspace": {
          "resourceType": "security-workspace",
          "template": "ari:cloud:jira:{siteId}:security-workspace/activation/{activationId}/{providerAppId}/{securityWorkspaceId}",
          "icon": {
            "source": "atlaskit-icon-lab",
            "importPath": "@atlaskit/icon-lab/core/spaces",
            "exportName": "default"
          }
        },
        "sprint": {
          "resourceType": "sprint",
          "template": "ari:cloud:jira:{siteId}:sprint/activation/{activationId}/{sprintId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/sprint",
            "exportName": "default"
          }
        },
        "version": {
          "resourceType": "version",
          "template": "ari:cloud:jira:{siteId}:version/activation/{activationId}/{versionId}",
          "icon": {
            "source": "atlaskit-icon-lab",
            "importPath": "@atlaskit/icon-lab/core/history",
            "exportName": "default"
          }
        },
        "vulnerability": {
          "resourceType": "vulnerability",
          "template": "ari:cloud:jira:{siteId}:vulnerability/activation/{activationId}/{vulnerabilityId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/flag-filled",
            "exportName": "default"
          }
        },
        "workspace": {
          "resourceType": "workspace",
          "template": "ari:cloud:jira:{siteId}:workspace/{activationId}",
          "icon": {
            "source": "atlaskit-icon-lab",
            "importPath": "@atlaskit/icon-lab/core/spaces",
            "exportName": "default"
          }
        }
      }
    },
    "jira-software": {
      "resourceOwner": "jira-software",
      "platform": "cloud",
      "isThirdParty": false,
      "displayName": "Jira Software",
      "logo": {
        "source": "atlaskit-logo",
        "importPath": "@atlaskit/logo/jira-software-icon",
        "exportName": "JiraSoftwareIcon"
      },
      "notNeeded": false,
      "resourceTypes": {
        "board": {
          "resourceType": "board",
          "template": "ari:cloud:jira-software:{siteId}:board/{boardId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/board",
            "exportName": "default"
          }
        }
      }
    },
    "cmdb": {
      "resourceOwner": "cmdb",
      "platform": "cloud",
      "isThirdParty": false,
      "displayName": "Assets",
      "logo": {
        "source": "atlaskit-raw-icon",
        "importPath": "@atlaskit/logo/raw-icons",
        "exportName": "assetsIcon"
      },
      "notNeeded": false,
      "resourceTypes": {
        "object": {
          "resourceType": "object",
          "template": "ari:cloud:cmdb::object/{workspaceId}/{objectId}",
          "icon": {
            "source": "atlaskit-icon-lab",
            "importPath": "@atlaskit/icon-lab/core/assets-object",
            "exportName": "default"
          }
        },
        "type": {
          "resourceType": "type",
          "template": "ari:cloud:cmdb::type/{workspaceId}/{typeId}",
          "icon": {
            "source": "atlaskit-icon-lab",
            "importPath": "@atlaskit/icon-lab/core/assets-object-type",
            "exportName": "default"
          }
        }
      }
    },
    "bitbucket": {
      "resourceOwner": "bitbucket",
      "platform": "cloud",
      "isThirdParty": false,
      "displayName": "Bitbucket",
      "logo": {
        "source": "atlaskit-logo",
        "importPath": "@atlaskit/logo/bitbucket-icon",
        "exportName": "BitbucketIcon"
      },
      "notNeeded": false,
      "resourceTypes": {
        "repository": {
          "resourceType": "repository",
          "template": "ari:cloud:bitbucket::repository/{repositoryId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/angle-brackets",
            "exportName": "default"
          }
        }
      }
    },
    "passionfruit": {
      "resourceOwner": "passionfruit",
      "platform": "cloud",
      "isThirdParty": false,
      "displayName": "Guard",
      "logo": {
        "source": "atlaskit-raw-icon",
        "importPath": "@atlaskit/logo/raw-icons",
        "exportName": "guardIcon"
      },
      "notNeeded": false,
      "resourceTypes": {
        "ask": {
          "resourceType": "ask",
          "template": "ari:cloud:passionfruit:{siteId}:ask/workspace/{activationId}/{askId}",
          "icon": {
            "source": "atlaskit-icon-lab",
            "importPath": "@atlaskit/icon-lab/core/ask",
            "exportName": "default"
          }
        },
        "dependency": {
          "resourceType": "dependency",
          "template": "ari:cloud:passionfruit:{siteId}:dependency/workspace/{activationId}/{dependencyId}",
          "icon": null
        },
        "plan": {
          "resourceType": "plan",
          "template": "ari:cloud:passionfruit:{siteId}:plan/workspace/{activationId}/{planId}",
          "icon": {
            "source": "atlaskit-icon-lab",
            "importPath": "@atlaskit/icon-lab/core/plan",
            "exportName": "default"
          }
        },
        "plan-scenario": {
          "resourceType": "plan-scenario",
          "template": "ari:cloud:passionfruit:{siteId}:plan-scenario/workspace/{activationId}/{planId}/{scenarioId}",
          "icon": {
            "source": "atlaskit-icon-lab",
            "importPath": "@atlaskit/icon-lab/core/plan",
            "exportName": "default"
          }
        },
        "plan-scenario-investment": {
          "resourceType": "plan-scenario-investment",
          "template": "ari:cloud:passionfruit:{siteId}:plan-scenario-investment/workspace/{activationId}/{planId}/{scenarioId}/{investmentId}",
          "icon": {
            "source": "atlaskit-icon-lab",
            "importPath": "@atlaskit/icon-lab/core/plan",
            "exportName": "default"
          }
        }
      }
    },
    "compass": {
      "resourceOwner": "compass",
      "platform": "cloud",
      "isThirdParty": false,
      "displayName": "Compass",
      "logo": {
        "source": "atlaskit-raw-icon",
        "importPath": "@atlaskit/logo/raw-icons",
        "exportName": "compassIcon"
      },
      "notNeeded": false,
      "resourceTypes": {
        "component-link": {
          "resourceType": "component-link",
          "template": "ari:cloud:compass:{siteId}:component-link/{workspaceId}/{componentId}/{componentLinkId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/link",
            "exportName": "default"
          }
        },
        "component": {
          "resourceType": "component",
          "template": "ari:cloud:compass:{siteId}:component/{workspaceId}/{componentId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/component",
            "exportName": "default"
          }
        },
        "scorecard": {
          "resourceType": "scorecard",
          "template": "ari:cloud:compass:{siteId}:scorecard/{workspaceId}/{scorecardId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/scorecard",
            "exportName": "default"
          }
        }
      }
    },
    "townsquare": {
      "resourceOwner": "townsquare",
      "platform": "cloud",
      "isThirdParty": false,
      "displayName": "Home",
      "logo": {
        "source": "atlaskit-raw-icon",
        "importPath": "@atlaskit/logo/raw-icons",
        "exportName": "homeIcon"
      },
      "notNeeded": false,
      "resourceTypes": {
        "comment": {
          "resourceType": "comment",
          "template": "ari:cloud:townsquare:{siteId}:comment/{commentUuid}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/comment",
            "exportName": "default"
          }
        },
        "goal": {
          "resourceType": "goal",
          "template": "ari:cloud:townsquare:{siteId}:goal/{goalUuid}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/goal",
            "exportName": "default"
          }
        },
        "goal-update": {
          "resourceType": "goal-update",
          "template": "ari:cloud:townsquare:{siteId}:goal-update/{goalUpdateUuid}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/goal",
            "exportName": "default"
          }
        },
        "project": {
          "resourceType": "project",
          "template": "ari:cloud:townsquare:{siteId}:project/{projectUuid}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/project",
            "exportName": "default"
          }
        },
        "project-update": {
          "resourceType": "project-update",
          "template": "ari:cloud:townsquare:{siteId}:project-update/{projectUpdateUuid}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/project",
            "exportName": "default"
          }
        },
        "tag": {
          "resourceType": "tag",
          "template": "ari:cloud:townsquare:{siteId}:tag/{tagUuid}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/tag",
            "exportName": "default"
          }
        }
      }
    },
    "opsgenie": {
      "resourceOwner": "opsgenie",
      "platform": "cloud",
      "isThirdParty": false,
      "displayName": "Opsgenie",
      "logo": {
        "source": "atlaskit-logo",
        "importPath": "@atlaskit/logo/opsgenie-icon",
        "exportName": "OpsgenieIcon"
      },
      "notNeeded": false,
      "resourceTypes": {
        "escalation": {
          "resourceType": "escalation",
          "template": "ari:cloud:opsgenie::escalation/{workspaceId}/{escalationId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/priority-critical",
            "exportName": "default"
          }
        },
        "schedule": {
          "resourceType": "schedule",
          "template": "ari:cloud:opsgenie::schedule/{workspaceId}/{scheduleId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/calendar",
            "exportName": "default"
          }
        },
        "team": {
          "resourceType": "team",
          "template": "ari:cloud:opsgenie:{siteId}:team/{opsgenieTeamId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/teams",
            "exportName": "default"
          }
        }
      }
    },
    "graph": {
      "resourceOwner": "graph",
      "platform": "cloud",
      "isThirdParty": false,
      "displayName": "External",
      "logo": null,
      "notNeeded": true,
      "resourceTypes": {
        "branch": {
          "resourceType": "branch",
          "template": "ari:cloud:graph::branch/activation/{activationId}/{branchId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/branch",
            "exportName": "default"
          }
        },
        "build": {
          "resourceType": "build",
          "template": "ari:cloud:graph::build/activation/{activationId}/{buildId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/release",
            "exportName": "default"
          }
        },
        "calendar-event": {
          "resourceType": "calendar-event",
          "template": "ari:cloud:graph::calendar-event/activation/{activationId}/{calendarEventId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/calendar",
            "exportName": "default"
          }
        },
        "commit": {
          "resourceType": "commit",
          "template": "ari:cloud:graph::commit/activation/{activationId}/{commitId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/commit",
            "exportName": "default"
          }
        },
        "conversation": {
          "resourceType": "conversation",
          "template": "ari:cloud:graph::conversation/activation/{activationId}/{entityUUID}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/comment",
            "exportName": "default"
          }
        },
        "customer-contact": {
          "resourceType": "customer-contact",
          "template": "ari:cloud:graph::customer-contact/activation/{activationId}/{customerContactId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/person-avatar",
            "exportName": "default"
          }
        },
        "dashboard": {
          "resourceType": "dashboard",
          "template": "ari:cloud:graph::dashboard/activation/{activationId}/{dashboardId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/dashboard",
            "exportName": "default"
          }
        },
        "deployment": {
          "resourceType": "deployment",
          "template": "ari:cloud:graph::deployment/activation/{activationId}/{deploymentId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/release",
            "exportName": "default"
          }
        },
        "design": {
          "resourceType": "design",
          "template": "ari:cloud:graph::design/activation/{activationId}/{designId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/whiteboard",
            "exportName": "default"
          }
        },
        "devops-component": {
          "resourceType": "devops-component",
          "template": "ari:cloud:graph::devops-component/activation/{activationId}/{devopsComponentId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/component",
            "exportName": "default"
          }
        },
        "document": {
          "resourceType": "document",
          "template": "ari:cloud:graph::document/activation/{activationId}/{documentId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/file",
            "exportName": "default"
          }
        },
        "experimental": {
          "resourceType": "experimental",
          "template": "ari:cloud:graph::experimental/activation/{activationId}/{experimentalId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/flag",
            "exportName": "default"
          }
        },
        "feature-flag": {
          "resourceType": "feature-flag",
          "template": "ari:cloud:graph::feature-flag/activation/{activationId}/{featureFlagId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/flag",
            "exportName": "default"
          }
        },
        "incident": {
          "resourceType": "incident",
          "template": "ari:cloud:graph::incident/activation/{activationId}/{incidentId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/incident",
            "exportName": "default"
          }
        },
        "customer-org": {
          "resourceType": "customer-org",
          "template": "ari:cloud:graph::customer-org/activation/{activationId}/{customerOrgId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/department",
            "exportName": "default"
          }
        },
        "customer-org-category": {
          "resourceType": "customer-org-category",
          "template": "ari:cloud:graph::customer-org-category/activation/{activationId}/{customerOrgCategoryId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/department",
            "exportName": "default"
          }
        },
        "data-table": {
          "resourceType": "data-table",
          "template": "ari:cloud:graph::data-table/activation/{activationId}/{dataTableId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/table",
            "exportName": "default"
          }
        },
        "message": {
          "resourceType": "message",
          "template": "ari:cloud:graph::message/activation/{activationId}/{entityUUID}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/comment",
            "exportName": "default"
          }
        },
        "operations-workspace": {
          "resourceType": "operations-workspace",
          "template": "ari:cloud:graph::operations-workspace/activation/{activationId}/{providerAppId}/{operationsWorkspaceId}",
          "icon": {
            "source": "atlaskit-icon-lab",
            "importPath": "@atlaskit/icon-lab/core/spaces",
            "exportName": "default"
          }
        },
        "deal": {
          "resourceType": "deal",
          "template": "ari:cloud:graph::deal/activation/{activationId}/{dealId}",
          "icon": null
        },
        "organisation": {
          "resourceType": "organisation",
          "template": "ari:cloud:graph::organisation/activation/{activationId}/{organisationUUID}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/office-building",
            "exportName": "default"
          }
        },
        "position": {
          "resourceType": "position",
          "template": "ari:cloud:graph::position/activation/{activationId}/{positionUUID}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/person",
            "exportName": "default"
          }
        },
        "post-incident-review": {
          "resourceType": "post-incident-review",
          "template": "ari:cloud:graph::post-incident-review/activation/{activationId}/{postIncidentReviewId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/incident",
            "exportName": "default"
          }
        },
        "project": {
          "resourceType": "project",
          "template": "ari:cloud:graph::project/activation/{activationId}/{projectId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/project",
            "exportName": "default"
          }
        },
        "pull-request": {
          "resourceType": "pull-request",
          "template": "ari:cloud:graph::pull-request/activation/{activationId}/{pullRequestId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/pull-request",
            "exportName": "default"
          }
        },
        "relationship-type": {
          "resourceType": "relationship-type",
          "template": "ari:cloud:graph::relationship-type/{relationshipTypeId}",
          "icon": null
        },
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:cloud:graph::remote-link/activation/{activationId}/{remoteLinkId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/link-external",
            "exportName": "default"
          }
        },
        "repository": {
          "resourceType": "repository",
          "template": "ari:cloud:graph::repository/activation/{activationId}/{repositoryId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/angle-brackets",
            "exportName": "default"
          }
        },
        "security-container": {
          "resourceType": "security-container",
          "template": "ari:cloud:graph::security-container/activation/{activationId}/{providerAppId}/{securityContainerId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/shield",
            "exportName": "default"
          }
        },
        "security-workspace": {
          "resourceType": "security-workspace",
          "template": "ari:cloud:graph::security-workspace/activation/{activationId}/{providerAppId}/{securityWorkspaceId}",
          "icon": {
            "source": "atlaskit-icon-lab",
            "importPath": "@atlaskit/icon-lab/core/spaces",
            "exportName": "default"
          }
        },
        "service": {
          "resourceType": "service",
          "template": "ari:cloud:graph::service/{workspaceId}/{serviceId}",
          "icon": {
            "source": "atlaskit-icon-lab",
            "importPath": "@atlaskit/icon-lab/core/service",
            "exportName": "default"
          }
        },
        "software-service": {
          "resourceType": "software-service",
          "template": "ari:cloud:graph::software-service/activation/{activationId}/{softwareServiceId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/angle-brackets",
            "exportName": "default"
          }
        },
        "team": {
          "resourceType": "team",
          "template": "ari:cloud:graph::team/activation/{activationId}/{teamId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/teams",
            "exportName": "default"
          }
        },
        "test": {
          "resourceType": "test",
          "template": "ari:cloud:graph::test/activation/{activationId}/{testId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/flask",
            "exportName": "default"
          }
        },
        "test-run": {
          "resourceType": "test-run",
          "template": "ari:cloud:graph::test-run/activation/{activationId}/{testRunId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/flask",
            "exportName": "default"
          }
        },
        "test-status": {
          "resourceType": "test-status",
          "template": "ari:cloud:graph::test-status/activation/{activationId}/{testStatusId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/flask",
            "exportName": "default"
          }
        },
        "test-execution": {
          "resourceType": "test-execution",
          "template": "ari:cloud:graph::test-execution/activation/{activationId}/{testExecutionId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/flask",
            "exportName": "default"
          }
        },
        "test-plan": {
          "resourceType": "test-plan",
          "template": "ari:cloud:graph::test-plan/activation/{activationId}/{testPlanId}",
          "icon": {
            "source": "atlaskit-icon-lab",
            "importPath": "@atlaskit/icon-lab/core/plan",
            "exportName": "default"
          }
        },
        "video": {
          "resourceType": "video",
          "template": "ari:cloud:graph::video/activation/{activationId}/{entityUUID}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/video",
            "exportName": "default"
          }
        },
        "vulnerability": {
          "resourceType": "vulnerability",
          "template": "ari:cloud:graph::vulnerability/activation/{activationId}/{vulnerabilityId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/flag-filled",
            "exportName": "default"
          }
        },
        "work-item": {
          "resourceType": "work-item",
          "template": "ari:cloud:graph::work-item/activation/{activationId}/{workItemId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/work-item",
            "exportName": "default"
          }
        },
        "worker": {
          "resourceType": "worker",
          "template": "ari:cloud:graph::worker/activation/{activationId}/{workerUUID}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/person",
            "exportName": "default"
          }
        },
        "space": {
          "resourceType": "space",
          "template": "ari:cloud:graph::space/activation/{activationId}/{entityUUID}",
          "icon": {
            "source": "atlaskit-icon-lab",
            "importPath": "@atlaskit/icon-lab/core/spaces",
            "exportName": "default"
          }
        },
        "comment": {
          "resourceType": "comment",
          "template": "ari:cloud:graph::comment/activation/{activationId}/{entityUUID}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/comment",
            "exportName": "default"
          }
        },
        "campaign": {
          "resourceType": "campaign",
          "template": "ari:cloud:graph::campaign/activation/{activationId}/{campaignId}",
          "icon": null
        },
        "case": {
          "resourceType": "case",
          "template": "ari:cloud:graph::case/activation/{activationId}/{caseId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/briefcase",
            "exportName": "default"
          }
        }
      }
    },
    "avp": {
      "resourceOwner": "avp",
      "platform": "cloud",
      "isThirdParty": false,
      "displayName": "Avp",
      "logo": null,
      "notNeeded": false,
      "resourceTypes": {
        "dashboard": {
          "resourceType": "dashboard",
          "template": "ari:cloud:avp:{siteId}:dashboard/activation/{activationId}/{dashboardId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/dashboard",
            "exportName": "default"
          }
        }
      }
    },
    "mercury": {
      "resourceOwner": "mercury",
      "platform": "cloud",
      "isThirdParty": false,
      "displayName": "Mercury",
      "logo": {
        "source": "atlaskit-raw-icon",
        "importPath": "@atlaskit/logo/raw-icons",
        "exportName": "focusIcon"
      },
      "notNeeded": false,
      "resourceTypes": {
        "change-proposal": {
          "resourceType": "change-proposal",
          "template": "ari:cloud:mercury:{siteId}:change-proposal/workspace/{workspaceId}/{changeProposalId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/changes",
            "exportName": "default"
          }
        },
        "focus-area-status-update": {
          "resourceType": "focus-area-status-update",
          "template": "ari:cloud:mercury:{siteId}:focus-area-status-update/workspace/{workspaceId}/{focusAreaStatusUpdateId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/focus-area",
            "exportName": "default"
          }
        },
        "focus-area": {
          "resourceType": "focus-area",
          "template": "ari:cloud:mercury:{siteId}:focus-area/workspace/{workspaceId}/{focusAreaId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/capture",
            "exportName": "default"
          }
        },
        "risk": {
          "resourceType": "risk",
          "template": "ari:cloud:mercury:{siteId}:risk/workspace/{workspaceId}/{riskId}",
          "icon": {
            "source": "atlaskit-icon-lab",
            "importPath": "@atlaskit/icon-lab/core/warning-outline",
            "exportName": "default"
          }
        },
        "strategic-event": {
          "resourceType": "strategic-event",
          "template": "ari:cloud:mercury:{siteId}:strategic-event/workspace/{workspaceId}/{strategicEventId}",
          "icon": null
        }
      }
    },
    "jira-align": {
      "resourceOwner": "jira-align",
      "platform": "cloud",
      "isThirdParty": false,
      "displayName": "Jira Align",
      "logo": {
        "source": "atlaskit-logo",
        "importPath": "@atlaskit/logo/jira-icon",
        "exportName": "JiraIcon"
      },
      "notNeeded": false,
      "resourceTypes": {
        "project": {
          "resourceType": "project",
          "template": "ari:cloud:jira-align:{instanceId}:project/{projectType}/{projectId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/project",
            "exportName": "default"
          }
        }
      }
    },
    "figma": {
      "resourceOwner": "figma",
      "platform": "third-party",
      "isThirdParty": false,
      "displayName": "Figma",
      "logo": {
        "source": "asset",
        "svgKey": "figma",
        "importPath": "assets/logos/figma.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "file": {
          "resourceType": "file",
          "template": "ari:third-party:figma::file/{fileId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/file",
            "exportName": "default"
          }
        }
      }
    },
    "dropbox.dropbox": {
      "resourceOwner": "dropbox.dropbox",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Dropbox",
      "logo": {
        "source": "asset",
        "svgKey": "dropbox",
        "importPath": "assets/logos/dropbox.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:dropbox.dropbox::remote-link/file/{fileId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/file",
            "exportName": "default"
          }
        }
      }
    },
    "docusign.docusign": {
      "resourceOwner": "docusign.docusign",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "DocuSign",
      "logo": {
        "source": "asset",
        "svgKey": "docusign",
        "importPath": "assets/logos/docusign.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "document": {
          "resourceType": "document",
          "template": "ari:third-party:docusign.docusign::document/shard/{shardRegion}/account/{accountId}/envelope/{envelopeId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/file",
            "exportName": "default"
          }
        },
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:docusign.docusign::remote-link/shard/{shardRegion}/account/{accountId}/envelope/{envelopeId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/file",
            "exportName": "default"
          }
        }
      }
    },
    "cisco.webex": {
      "resourceOwner": "cisco.webex",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Webex",
      "logo": {
        "source": "asset",
        "svgKey": "webex",
        "importPath": "assets/logos/webex.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:cisco.webex::remote-link/recording/{recordingId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/video",
            "exportName": "default"
          }
        }
      }
    },
    "mural.mural": {
      "resourceOwner": "mural.mural",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Mural",
      "logo": {
        "source": "asset",
        "svgKey": "mural",
        "importPath": "assets/logos/mural.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:mural.mural::remote-link/design/{designId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/whiteboard",
            "exportName": "default"
          }
        }
      }
    },
    "airtable.airtable": {
      "resourceOwner": "airtable.airtable",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Airtable",
      "logo": {
        "source": "asset",
        "svgKey": "airtable",
        "importPath": "assets/logos/airtable.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "document": {
          "resourceType": "document",
          "template": "ari:third-party:airtable.airtable::document/{compositeAirtableDocument}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/file",
            "exportName": "default"
          }
        },
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:airtable.airtable::remote-link/base/{baseId}/table/{tableId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/database",
            "exportName": "default"
          }
        }
      }
    },
    "asana.asana": {
      "resourceOwner": "asana.asana",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Asana",
      "logo": {
        "source": "asset",
        "svgKey": "asana",
        "importPath": "assets/logos/asana.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:asana.asana::remote-link/task/{taskId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/task",
            "exportName": "default"
          }
        }
      }
    },
    "box.box": {
      "resourceOwner": "box.box",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Box",
      "logo": {
        "source": "asset",
        "svgKey": "box",
        "importPath": "assets/logos/box.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "document": {
          "resourceType": "document",
          "template": "ari:third-party:box.box::document/{item}/{itemId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/file",
            "exportName": "default"
          }
        },
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:box.box::remote-link/file/{fileId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/file",
            "exportName": "default"
          }
        }
      }
    },
    "gitlab.gitlab": {
      "resourceOwner": "gitlab.gitlab",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "GitLab",
      "logo": {
        "source": "asset",
        "svgKey": "gitlab",
        "importPath": "assets/logos/gitlab.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:gitlab.gitlab::remote-link/{category}/{remoteLinkId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/branch",
            "exportName": "default"
          }
        }
      }
    },
    "lucid.lucidchart": {
      "resourceOwner": "lucid.lucidchart",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Lucidchart",
      "logo": {
        "source": "asset",
        "svgKey": "lucidchart",
        "importPath": "assets/logos/lucidchart.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:lucid.lucidchart::remote-link/chart/{chartId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/whiteboard",
            "exportName": "default"
          }
        }
      }
    },
    "miro.miro": {
      "resourceOwner": "miro.miro",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Miro",
      "logo": {
        "source": "asset",
        "svgKey": "miro",
        "importPath": "assets/logos/miro.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:miro.miro::remote-link/board/{boardId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/link-external",
            "exportName": "default"
          }
        }
      }
    },
    "monday.monday": {
      "resourceOwner": "monday.monday",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Monday.com",
      "logo": {
        "source": "asset",
        "svgKey": "monday",
        "importPath": "assets/logos/monday.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "document": {
          "resourceType": "document",
          "template": "ari:third-party:monday.monday::document/board/{boardId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/file",
            "exportName": "default"
          }
        }
      }
    },
    "notion.notion": {
      "resourceOwner": "notion.notion",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Notion",
      "logo": {
        "source": "asset",
        "svgKey": "notion",
        "importPath": "assets/logos/notion.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "document": {
          "resourceType": "document",
          "template": "ari:third-party:notion.notion::document/page/{pageId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/file",
            "exportName": "default"
          }
        },
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:notion.notion::remote-link/page/{pageId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/file",
            "exportName": "default"
          }
        }
      }
    },
    "smartsheet.smartsheet": {
      "resourceOwner": "smartsheet.smartsheet",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Smartsheet",
      "logo": {
        "source": "asset",
        "svgKey": "smartsheet",
        "importPath": "assets/logos/smartsheet.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "document": {
          "resourceType": "document",
          "template": "ari:third-party:smartsheet.smartsheet::document/sheet/{sheetId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/file",
            "exportName": "default"
          }
        },
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:smartsheet.smartsheet::remote-link/sheet/{sheetId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/spreadsheet",
            "exportName": "default"
          }
        }
      }
    },
    "devai": {
      "resourceOwner": "devai",
      "platform": "cloud",
      "isThirdParty": false,
      "displayName": "Devai",
      "logo": {
        "source": "atlaskit-logo",
        "importPath": "@atlaskit/logo/atlassian-icon",
        "exportName": "AtlassianIcon"
      },
      "notNeeded": false,
      "resourceTypes": {
        "autodev-job": {
          "resourceType": "autodev-job",
          "template": "ari:cloud:devai::autodev-job/{workspaceId}/{jobId}",
          "icon": {
            "source": "atlaskit-icon-lab",
            "importPath": "@atlaskit/icon-lab/core/ai-bot",
            "exportName": "default"
          }
        }
      }
    },
    "radar": {
      "resourceOwner": "radar",
      "platform": "cloud",
      "isThirdParty": false,
      "displayName": "Radar",
      "logo": null,
      "notNeeded": true,
      "resourceTypes": {
        "position": {
          "resourceType": "position",
          "template": "ari:cloud:radar:{siteId}:position/{workspaceId}/{positionId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/person",
            "exportName": "default"
          }
        },
        "worker": {
          "resourceType": "worker",
          "template": "ari:cloud:radar:{siteId}:worker/{workspaceId}/{workerId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/person",
            "exportName": "default"
          }
        }
      }
    },
    "figma.figma": {
      "resourceOwner": "figma.figma",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Figma",
      "logo": {
        "source": "asset",
        "svgKey": "figma",
        "importPath": "assets/logos/figma.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "design": {
          "resourceType": "design",
          "template": "ari:third-party:figma.figma::design/{designId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/whiteboard",
            "exportName": "default"
          }
        },
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:figma.figma::remote-link/{remoteLinkId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/pen",
            "exportName": "default"
          }
        }
      }
    },
    "google.google-drive": {
      "resourceOwner": "google.google-drive",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Google Drive",
      "logo": {
        "source": "asset",
        "svgKey": "google_drive",
        "importPath": "assets/logos/google_drive.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "document": {
          "resourceType": "document",
          "template": "ari:third-party:google.google-drive::document/{googleDriveDocumentIdType}/{docId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/file",
            "exportName": "default"
          }
        },
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:google.google-drive::remote-link/file/{fileId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/file",
            "exportName": "default"
          }
        },
        "video": {
          "resourceType": "video",
          "template": "ari:third-party:google.google-drive::video/{videoId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/video",
            "exportName": "default"
          }
        }
      }
    },
    "slack.slack": {
      "resourceOwner": "slack.slack",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Slack",
      "logo": {
        "source": "asset",
        "svgKey": "slack",
        "importPath": "assets/logos/slack.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "conversation": {
          "resourceType": "conversation",
          "template": "ari:third-party:slack.slack::conversation/workspaceId/{workspaceId}/channelId/{channelId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/comment",
            "exportName": "default"
          }
        },
        "message": {
          "resourceType": "message",
          "template": "ari:third-party:slack.slack::message/workspaceId/{workspaceId}/channelId/{channelId}/messageId/{messageId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/comment",
            "exportName": "default"
          }
        }
      }
    },
    "microsoft.onedrive": {
      "resourceOwner": "microsoft.onedrive",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "OneDrive",
      "logo": {
        "source": "asset",
        "svgKey": "microsoft_onedrive",
        "importPath": "assets/logos/onedrive.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "document": {
          "resourceType": "document",
          "template": "ari:third-party:microsoft.onedrive::document/driveId/{driveId}/fileId/{fileId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/file",
            "exportName": "default"
          }
        }
      }
    },
    "microsoft.power-bi": {
      "resourceOwner": "microsoft.power-bi",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Power BI",
      "logo": {
        "source": "asset",
        "svgKey": "azure_power_bi_embedded",
        "importPath": "assets/logos/power_bi.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:microsoft.power-bi::remote-link/reportId/{reportId}",
          "icon": {
            "source": "atlaskit-icon-lab",
            "importPath": "@atlaskit/icon-lab/core/chart-bar-line",
            "exportName": "default"
          }
        }
      }
    },
    "clickup.clickup": {
      "resourceOwner": "clickup.clickup",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "ClickUp",
      "logo": {
        "source": "asset",
        "svgKey": "clickup",
        "importPath": "assets/logos/clickup.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:clickup.clickup::remote-link/task/{taskId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/task",
            "exportName": "default"
          }
        }
      }
    },
    "amplitude.amplitude": {
      "resourceOwner": "amplitude.amplitude",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Amplitude",
      "logo": {
        "source": "asset",
        "svgKey": "amplitude",
        "importPath": "assets/logos/amplitude.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:amplitude.amplitude::remote-link/org/{orgId}/chart/{chartId}",
          "icon": {
            "source": "atlaskit-icon-lab",
            "importPath": "@atlaskit/icon-lab/core/chart-bar-line",
            "exportName": "default"
          }
        }
      }
    },
    "adobe.adobexd": {
      "resourceOwner": "adobe.adobexd",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Adobe XD",
      "logo": {
        "source": "asset",
        "svgKey": "xd",
        "importPath": "assets/logos/adobexd.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:adobe.adobexd::remote-link/file/{fileId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/file",
            "exportName": "default"
          }
        }
      }
    },
    "stripe.stripe": {
      "resourceOwner": "stripe.stripe",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Stripe",
      "logo": {
        "source": "asset",
        "svgKey": "stripe",
        "importPath": "assets/logos/stripe.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:stripe.stripe::remote-link/invoice/{invoiceId}",
          "icon": {
            "source": "atlaskit-icon-lab",
            "importPath": "@atlaskit/icon-lab/core/diagram-symbol-file",
            "exportName": "default"
          }
        }
      }
    },
    "dovetail.dovetail": {
      "resourceOwner": "dovetail.dovetail",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Dovetail",
      "logo": {
        "source": "asset",
        "svgKey": "dovetail",
        "importPath": "assets/logos/dovetail.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:dovetail.dovetail::remote-link/org/{orgId}/note/{noteId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/note",
            "exportName": "default"
          }
        }
      }
    },
    "pipedrive.pipedrive": {
      "resourceOwner": "pipedrive.pipedrive",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Pipedrive",
      "logo": {
        "source": "asset",
        "svgKey": "pipedrive",
        "importPath": "assets/logos/pipedrive.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:pipedrive.pipedrive::remote-link/org/{orgId}/deal/{dealId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/link-external",
            "exportName": "default"
          }
        }
      }
    },
    "zeplin.zeplin": {
      "resourceOwner": "zeplin.zeplin",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Zeplin",
      "logo": {
        "source": "asset",
        "svgKey": "zeplin",
        "importPath": "assets/logos/zeplin.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:zeplin.zeplin::remote-link/{remoteLinkId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/pen",
            "exportName": "default"
          }
        }
      }
    },
    "github.github": {
      "resourceOwner": "github.github",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "GitHub",
      "logo": {
        "source": "asset",
        "svgKey": "github",
        "importPath": "assets/logos/github.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "build": {
          "resourceType": "build",
          "template": "ari:third-party:github.github::build/pipelineId/{pipelineId}/buildId/{buildId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/release",
            "exportName": "default"
          }
        },
        "repository": {
          "resourceType": "repository",
          "template": "ari:third-party:github.github::repository/{repositoryId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/angle-brackets",
            "exportName": "default"
          }
        },
        "branch": {
          "resourceType": "branch",
          "template": "ari:third-party:github.github::branch/repositoryId/{repositoryId}/branchId/{branchId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/branch",
            "exportName": "default"
          }
        },
        "deployment": {
          "resourceType": "deployment",
          "template": "ari:third-party:github.github::deployment/pipelineId/{pipelineId}/environmentId/{environmentId}/deploymentSequenceNumber/{deploymentSequenceNumber}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/release",
            "exportName": "default"
          }
        },
        "vulnerability": {
          "resourceType": "vulnerability",
          "template": "ari:third-party:github.github::vulnerability/{vulnerabilityId}",
          "icon": {
            "source": "atlaskit-icon-lab",
            "importPath": "@atlaskit/icon-lab/core/vulnerability",
            "exportName": "default"
          }
        },
        "pull-request": {
          "resourceType": "pull-request",
          "template": "ari:third-party:github.github::pull-request/repositoryId/{repositoryId}/pullRequestId/{pullRequestId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/pull-request",
            "exportName": "default"
          }
        },
        "commit": {
          "resourceType": "commit",
          "template": "ari:third-party:github.github::commit/repositoryId/{repositoryId}/commitId/{commitId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/commit",
            "exportName": "default"
          }
        },
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:github.github::remote-link/{remoteLinkId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/link",
            "exportName": "default"
          }
        },
        "comment": {
          "resourceType": "comment",
          "template": "ari:third-party:github.github::comment/repositoryId/{repositoryId}/pullRequestId/{pullRequestId}/comment/{commentId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/comment",
            "exportName": "default"
          }
        }
      }
    },
    "pagerduty.pagerduty": {
      "resourceOwner": "pagerduty.pagerduty",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "PagerDuty",
      "logo": {
        "source": "asset",
        "svgKey": "pagerduty",
        "importPath": "assets/logos/pagerduty.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:pagerduty.pagerduty::remote-link/incident/{incidentId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/incident",
            "exportName": "default"
          }
        }
      }
    },
    "todoist.todoist": {
      "resourceOwner": "todoist.todoist",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Todoist",
      "logo": {
        "source": "asset",
        "svgKey": "todoist",
        "importPath": "assets/logos/todoist.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:todoist.todoist::remote-link/task/{taskId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/check-circle",
            "exportName": "default"
          }
        }
      }
    },
    "salesforce.salesforce": {
      "resourceOwner": "salesforce.salesforce",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Salesforce",
      "logo": {
        "source": "asset",
        "svgKey": "salesforce",
        "importPath": "assets/logos/salesforce.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:salesforce.salesforce::remote-link/org/{orgId}/opportunity/{opportunityId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/lightbulb",
            "exportName": "default"
          }
        }
      }
    },
    "microsoft.teams": {
      "resourceOwner": "microsoft.teams",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Microsoft Teams",
      "logo": {
        "source": "asset",
        "svgKey": "microsoft_teams",
        "importPath": "assets/logos/microsoft_teams.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "conversation": {
          "resourceType": "conversation",
          "template": "ari:third-party:microsoft.teams::conversation/{compositeConversation}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/comment",
            "exportName": "default"
          }
        },
        "message": {
          "resourceType": "message",
          "template": "ari:third-party:microsoft.teams::message/{compositeMessage}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/comment",
            "exportName": "default"
          }
        },
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:microsoft.teams::remote-link/teamId/{teamId}/channelId/{channelId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/hashtag",
            "exportName": "default"
          }
        }
      }
    },
    "hubspot.hubspot": {
      "resourceOwner": "hubspot.hubspot",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "HubSpot",
      "logo": {
        "source": "asset",
        "svgKey": "hubspot",
        "importPath": "assets/logos/hubspot.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:hubspot.hubspot::remote-link/deal/{dealId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/link-external",
            "exportName": "default"
          }
        }
      }
    },
    "microsoft.sharepoint": {
      "resourceOwner": "microsoft.sharepoint",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "SharePoint",
      "logo": {
        "source": "asset",
        "svgKey": "microsoft_sharepoint",
        "importPath": "assets/logos/microsoft_sharepoint.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "document": {
          "resourceType": "document",
          "template": "ari:third-party:microsoft.sharepoint::document/{sharepointDocument}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/file",
            "exportName": "default"
          }
        }
      }
    },
    "launchdarkly.launchdarkly": {
      "resourceOwner": "launchdarkly.launchdarkly",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "LaunchDarkly",
      "logo": {
        "source": "asset",
        "svgKey": "launchdarkly",
        "importPath": "assets/logos/launchdarkly.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:launchdarkly.launchdarkly::remote-link/feature-flag/{projectId}/{featureFlagKey}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/flag",
            "exportName": "default"
          }
        }
      }
    },
    "sentry.sentry": {
      "resourceOwner": "sentry.sentry",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Sentry",
      "logo": {
        "source": "asset",
        "svgKey": "sentry",
        "importPath": "assets/logos/sentry.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:sentry.sentry::remote-link/org/{orgId}/issue/{issueId}",
          "icon": {
            "source": "atlaskit-icon-lab",
            "importPath": "@atlaskit/icon-lab/core/warning-outline",
            "exportName": "default"
          }
        }
      }
    },
    "loom.loom": {
      "resourceOwner": "loom.loom",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Loom",
      "logo": {
        "source": "asset",
        "svgKey": "loom",
        "importPath": "assets/logos/loom.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "video": {
          "resourceType": "video",
          "template": "ari:third-party:loom.loom::video/{videoId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/video",
            "exportName": "default"
          }
        }
      }
    },
    "knowledge-serving-and-access": {
      "resourceOwner": "knowledge-serving-and-access",
      "platform": "cloud",
      "isThirdParty": false,
      "displayName": "Knowledge Access",
      "logo": null,
      "notNeeded": false,
      "resourceTypes": {
        "topic": {
          "resourceType": "topic",
          "template": "ari:cloud:knowledge-serving-and-access:{siteId}:topic/{topicId}",
          "icon": null
        }
      }
    },
    "azure-devops.azure-devops": {
      "resourceOwner": "azure-devops.azure-devops",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Azure DevOps",
      "logo": {
        "source": "asset",
        "svgKey": "azure_azure_devops",
        "importPath": "assets/logos/azure_devops.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "remote-link": {
          "resourceType": "remote-link",
          "template": "ari:third-party:azure-devops.azure-devops::remote-link/organization/{organization}/project/{projectId}/repository/{repositoryId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/angle-brackets",
            "exportName": "default"
          }
        }
      }
    },
    "google.google-drive-rsl": {
      "resourceOwner": "google.google-drive-rsl",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Google Drive",
      "logo": {
        "source": "asset",
        "svgKey": "google_drive",
        "importPath": "assets/logos/google_drive.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "document": {
          "resourceType": "document",
          "template": "ari:third-party:google.google-drive-rsl::document/{googleDriveDocumentIdType}/{docId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/file",
            "exportName": "default"
          }
        }
      }
    },
    "google.google-drive-lite": {
      "resourceOwner": "google.google-drive-lite",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Google Drive",
      "logo": {
        "source": "asset",
        "svgKey": "google_drive",
        "importPath": "assets/logos/google_drive.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "document": {
          "resourceType": "document",
          "template": "ari:third-party:google.google-drive-lite::document/{googleDriveDocumentIdType}/{docId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/file",
            "exportName": "default"
          }
        }
      }
    },
    "customer-three-sixty": {
      "resourceOwner": "customer-three-sixty",
      "platform": "cloud",
      "isThirdParty": false,
      "displayName": "Customer Three Sixty",
      "logo": null,
      "notNeeded": false,
      "resourceTypes": {
        "customer": {
          "resourceType": "customer",
          "template": "ari:cloud:customer-three-sixty::customer/{customerId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/person",
            "exportName": "default"
          }
        }
      }
    },
    "customer-service-management": {
      "resourceOwner": "customer-service-management",
      "platform": "cloud",
      "isThirdParty": false,
      "displayName": "Customer Service",
      "logo": {
        "source": "atlaskit-raw-icon",
        "importPath": "@atlaskit/logo/raw-icons",
        "exportName": "customerServiceManagementIcon"
      },
      "notNeeded": false,
      "resourceTypes": {
        "customer": {
          "resourceType": "customer",
          "template": "ari:cloud:customer-service-management::customer/activation/{activationId}/{customerId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/person",
            "exportName": "default"
          }
        },
        "organization": {
          "resourceType": "organization",
          "template": "ari:cloud:customer-service-management::organization/activation/{activationId}/{organizationId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/office-building",
            "exportName": "default"
          }
        }
      }
    },
    "secoda": {
      "resourceOwner": "secoda",
      "platform": "cloud",
      "isThirdParty": false,
      "displayName": "Secoda",
      "logo": null,
      "notNeeded": false,
      "resourceTypes": {
        "entity": {
          "resourceType": "entity",
          "template": "ari:cloud:secoda:{siteId}:entity/{activationId}/{entityPath}",
          "icon": {
            "source": "atlaskit-icon-lab",
            "importPath": "@atlaskit/icon-lab/core/assets-object",
            "exportName": "default"
          }
        }
      }
    },
    "google.google-calendar": {
      "resourceOwner": "google.google-calendar",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Google Calendar",
      "logo": {
        "source": "asset",
        "svgKey": "google_calendar",
        "importPath": "assets/logos/google_calendar.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "calendar-event": {
          "resourceType": "calendar-event",
          "template": "ari:third-party:google.google-calendar::calendar-event/calendarId/{calendarId}/eventId/{eventId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/calendar",
            "exportName": "default"
          }
        }
      }
    },
    "workday.workday": {
      "resourceOwner": "workday.workday",
      "platform": "third-party",
      "isThirdParty": true,
      "displayName": "Workday",
      "logo": {
        "source": "asset",
        "svgKey": "workday",
        "importPath": "assets/logos/workday.svg"
      },
      "notNeeded": false,
      "resourceTypes": {
        "worker": {
          "resourceType": "worker",
          "template": "ari:third-party:workday.workday::worker/{workerId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/person",
            "exportName": "default"
          }
        },
        "organisation": {
          "resourceType": "organisation",
          "template": "ari:third-party:workday.workday::organisation/{orgId}",
          "icon": {
            "source": "atlaskit-icon",
            "importPath": "@atlaskit/icon/core/office-building",
            "exportName": "default"
          }
        }
      }
    }
  }
}